import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useState } from "react";
import TableAutoComponent from "../../../../components/complex/crud/TableAutoComponent";
import generateTableConfigs from "../../../../utils/TableConfigGenerator";

const firstDateOfMonth = new Date();
firstDateOfMonth.setDate(1);
firstDateOfMonth.setHours(0, 0, 0, 0);

const today = new Date();

const customColumns = [
  {
    field: "movement",
    component: (rowData) => {
      if (rowData) {
        // const type = rowData.type;
        const point = rowData.point;
        return point.toLocaleString("id-ID", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 0,
        });
      } else {
        return "";
      }
    },
  },
];

const configs = [
  // add_configs
  {
    name: "Date",
    field: "transaction_date",
    type: "date_date",
    table: true,
  },
  {
    name: "Description",
    field: "description",
    type: "text_plain",
    table: true,
    filter: true,
  },
  {
    name: "+ / -",
    field: "movement",
    type: "number_plain",
    align: "right",
    table: true,
  },
];

const tableConfigs = generateTableConfigs(configs);

const PointHistory = (props) => {
  const { onLoad, data, loading } = props;

  const [selectedDate, setSelectedDate] = useState([firstDateOfMonth, today]);

  const handleOnClickLoad = () => {
    let fromDate = selectedDate.length > 0 ? selectedDate[0] : null;
    let toDate = selectedDate.length > 1 ? selectedDate[1] : null;

    if (fromDate && toDate && onLoad) onLoad({ fromDate, toDate });
  };

  return (
    <div className="col-start-start gap-4">
      <div className="row-start-end gap-2 w-full">
        <div className="col-start-start">
          <span className="font-semibold text-sm text-zinc-400">
            Transaction Date
          </span>
          <Calendar
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.value)}
            selectionMode="range"
            readOnlyInput
            showIcon
            showButtonBar
          />
        </div>
        <Button
          className="w-[6rem] min-h-[2.6rem]"
          icon="pi pi-refresh"
          label="Load"
          onClick={handleOnClickLoad}
        />
      </div>
      <div className={`col-center-center w-100 gap-2`}>
        <TableAutoComponent
          singleMode={false}
          selection={[]}
          onSelectionChange={() => {}}
          configs={tableConfigs}
          loading={loading}
          value={data}
          customColumns={customColumns}
          // auto pagination
          rows={10}
          paginator={true}
          rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
        />
      </div>
    </div>
  );
};

export default PointHistory;
